// extracted by mini-css-extract-plugin
export var pillTrigger = "_62-0";